
<template>
  <div>
    <div v-if="!user">
      <v-img
        src="@/assets/negotiation_header.png"
        style="margin: auto;"
        max-height="100%"
        min-height="100"
        max-width="100%"
      ></v-img>
    </div>
    <v-container fluid>
      <!-- <page-header v-if="user" :title="$route.params.negotiation_id ? 'Acompanhar Negociação' : 'Nova negociação'"/> -->
      <v-alert v-if="!has_token" type="warning" :value="true">
        <span class="title mt-n1">
          Atenção, esse link está incompleto.
        </span>
      </v-alert>

      <v-alert v-if="!is_diff_token" type="warning" :value="true">
        <span class="title mt-n1">
          Atenção, esse link é da sua própria empresa.
        </span>
      </v-alert>

      <v-row justify="center">
        <v-col cols="12" sm="8" md="8" lg="6" align-self="center">
          <negotiation-form v-if="has_token && is_diff_token" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'NewNegotiation',

  components: {
    NegotiationForm: () => import ('./form/NegotiationForm.vue'),
  },
  methods: {
    
  },
  computed: {
    has_token(){
      return !!this.$route.query.tk 
    },
    is_diff_token(){
      return true //this.has_token && this.$route.query.tk != localStorage.company_tk
    },
    page_token(){
      return this.$route.query.tk
    },
    ...mapState({
      user: state => state.User.user
    })
  },
}

</script>
<style scoped>

</style>